<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold py-5">{{ 'v3-byoc-popup-create-mission-title' | translate }}</div>
        <div class="text-s mb-4">{{ 'v3-byoc-popup-create-mission-description' | translate }}</div>
        <div
            class="text-s border-b border-dark pb-5"
            [innerHTML]="
                'v3-byoc-popup-create-mission-more-information' | translate: { helpLink: 'https://help.socialtalent.com/stpkb/add-any-content-how-to-do-it' }
            "
        ></div>
    </div>

    <div class="flex-grow-1">
        <div #ps class="pb-4 pt-5 px-4 relative inner" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }">
            <ng-container *ngIf="loaded">
                <!-- Name -->
                <div class="mb-4">
                    <label for="missionName" class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-mission-general-name-label</label>
                    <input
                        id="missionName"
                        (keydown.enter)="nextClick()"
                        class="w-100 info"
                        type="text"
                        maxlength="56"
                        [formControl]="controlName"
                        [ngClass]="{ 'danger-solid': (controlName.invalid && controlName.dirty) || isNameExists }"
                        [placeholder]="'v3-byoc-popup-create-mission-general-name-placeholder' | translate"
                        formControlDataTest="name"
                    />
                    <div *ngIf="isNameTooLong" class="text-danger text-xs mt-2 font-semi-bold" translate>v3-title-character-limit-reached</div>
                    <div *ngIf="isNameExists" class="rounded p-2 bg-danger mt-2 font-semi-bold text-xs text-white" translate>
                        v3-create-edit-mission-name-exists-error
                    </div>
                </div>

                <!-- Summary/Description/Content -->
                <div>
                    <label for="missionAbout" class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-mission-general-summary-label</label>
                    <textarea
                        id="missionAbout"
                        class="w-100 info"
                        type="text"
                        [formControl]="controlDescription"
                        [ngClass]="{ 'danger-solid': controlDescription.invalid && controlDescription.dirty }"
                        [placeholder]="'v3-byoc-popup-create-mission-general-summary-placeholder' | translate"
                        formControlDataTest="about"
                    ></textarea>
                </div>
            </ng-container>

            <div *ngIf="!loaded || saving" class="py-6">
                <app-loader loaderType="cover" overlayColor="white"></app-loader>
            </div>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4 pt-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button
            *ngIf="!isSubmodalOfAddingCourse"
            (click)="nextClick()"
            class="btn btn-secondary"
            [ngClass]="[invalid ? 'btn-disabled' : 'btn-secondary']"
            buttonDataTest="continueButton"
        >
            <span translate>v3-button-continue</span>
            <app-loader loaderSize="s" *ngIf="isChecking" loaderType="button" loaderColor="white" overlayColor="darkest"></app-loader>
        </button>
        <button
            *ngIf="isSubmodalOfAddingCourse"
            (click)="saveClick()"
            class="btn btn-primary"
            [ngClass]="[invalid ? 'btn-disabled' : 'btn-secondary']"
            buttonDataTest="continueButton"
        >
            <span translate>v3-button-continue</span>
            <app-loader loaderSize="s" *ngIf="isChecking" loaderType="button" loaderColor="white" overlayColor="darkest"></app-loader>
        </button>
    </div>
</div>
